import { TimesheetSettlementType } from 'app/constants/configuration/timesheetSettlementType'

export const getTimesheetSettlementTypeName = (
  timesheetSettlementType: TimesheetSettlementType,
  translate: (string) => string,
): string => {
  const text: string = TimesheetSettlementType[timesheetSettlementType]
  return translate(`timesheetSettlementType.${text}`)
}
